"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRateLimiter = exports.rateLimitedAxios = void 0;
const axios_1 = __importDefault(require("axios"));
const axios_rate_limit_1 = __importDefault(require("axios-rate-limit"));
const p_ratelimit_1 = require("p-ratelimit");
const config_1 = require("../config");
/**
 * can only be used with axios
 * @param rate max requests threshold
 * @param interval in miliseconds
 * @param axiosInstance for testing purpose
 * @returns rate limited "axios"
 */
const rateLimitedAxios = (rate, interval = config_1.DEFAULT_RATE_LIMITER_INTERVAL_IN_MS, axiosInstance) => (0, axios_rate_limit_1.default)(axiosInstance || axios_1.default, { maxRequests: rate, perMilliseconds: interval });
exports.rateLimitedAxios = rateLimitedAxios;
/**
 * Generic rate limiter creator, can be used with any function that returns a promise
 * @param rate
 * @param interval
 * @returns rate limiter function wrappper
 * usage:
 *   const rateLimiter = createRateLimiter()
 *   rateLimiter(() => fn(...args))
 */
const createRateLimiter = (rate, interval = config_1.DEFAULT_RATE_LIMITER_INTERVAL_IN_MS) => (0, p_ratelimit_1.pRateLimit)({
    interval,
    rate,
});
exports.createRateLimiter = createRateLimiter;
